import { Component } from '@angular/core';
import { JohnDeereAuthService } from '../../services/john-deere-auth.service';

@Component({
  selector: 'app-jd-connect',
  standalone: false,
  templateUrl: './jd-connect.component.html',
  styleUrls: ['./jd-connect.component.css']
})
export class JdConnectComponent {

  loading = false;
  error = '';

  constructor(private jdAuthService: JohnDeereAuthService) {}

  connect(): void {
    this.loading = true;
    this.error = '';
    this.jdAuthService.getAuthoriseUrl().subscribe({
      next: (response) => {
        window.location.href = response.authoriseUrl;
      },
      error: () => {
        this.loading = false;
        this.error = 'Failed to initiate connection. Please try again.';
      }
    });
  }
}
